import React, { useState, useRef, useEffect } from "react";
import { Checkbox } from "antd";
import { ReactComponent as ChevronDown } from "../../assets/Icons/dropdown.svg"; // Replace with your path
import "./CheckboxFilterDropdown.scss";

// const CheckboxFilterDropdown = ({
//   label = "Products",
//   options = [],
//   selected = [],
//   onChange,
// }) => {
//   const [open, setOpen] = useState(false);
//   const [selectedOptions, setSelectedOptions] = useState([]);

//   const ref = useRef();

//   const didInit = useRef(false);

//   useEffect(() => {
//     if (!didInit.current && options?.length > 0) {
//       const allValues = options.map((opt) => opt.value);
//       setSelectedOptions(allValues);
//       onChange && onChange(allValues);
//       didInit.current = true;
//     }
//   }, [options]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) setOpen(false);
//     };
//     if (open) document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [open]);

//   const handleCheckboxChange = (value) => {
//     let updated;
//     if (selectedOptions.includes(value)) {
//       updated = selectedOptions.filter((v) => v !== value);
//     } else {
//       updated = [...selectedOptions, value];
//     }
//     setSelectedOptions(updated);
//     onChange && onChange(updated);
//   };

//   return (
//     <div className="checkbox-filter-dropdown" ref={ref}>
//       <button
//         className={`dropdown-trigger${open ? " open" : ""}`}
//         onClick={() => setOpen((o) => !o)}
//       >
//         {label}
//         <ChevronDown
//           style={{
//             transform: open ? "rotate(180deg)" : "rotate(0deg)",
//             transition: "transform 0.3s ease",
//           }}
//         />
//       </button>

//       {open && (
//         <div className="dropdown-panel">
//           <div className="options-list">
//             {options.length === 0 ? (
//               <div className="no-options">No options</div>
//             ) : (
//               options.map((opt) => (
//                 <Checkbox
//                   key={opt.value}
//                   checked={selectedOptions.includes(opt.value)}
//                   onChange={() => handleCheckboxChange(opt.value)}
//                   className="option-checkbox"
//                 >
//                   {opt.label}
//                 </Checkbox>
//               ))
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

const CheckboxFilterDropdown = ({
  label = "Products",
  options = [],
  selected = [],
  onChange,
  handleApplyFilter = () => { }
}) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState([])
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleCheckboxChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    let updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange && onChange(updated);
    setValues(updated);
  };

  // useEffect(() => {
  //   if (!open) {
  //     handleApplyFilter(values)
  //   }
  // }, [open])
  return (
    <div className="checkbox-filter-dropdown" ref={ref}>
      <button
        className={`dropdown-trigger${open ? " open" : ""}`}
        onClick={() => setOpen((o) => !o)}
      >
        {label}
        <ChevronDown
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        />
      </button>

      {open && (
        <div className="dropdown-panel">
          <div className="options-list">
            {options.length === 0 ? (
              <div className="no-options">No options</div>
            ) : (
              options.map((opt) => (
                <Checkbox
                  key={opt.value}
                  checked={selected.includes(opt.value)}
                  onChange={(e) => handleCheckboxChange(e, opt.value)}
                  className="option-checkbox"
                >
                  {opt.label}
                </Checkbox>
              ))
            )}
          </div>
          <button
            className="apply-btn"
            style={{ marginTop: 8, width: '100%', padding: '6px 0', background: '#f2654a', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              handleApplyFilter(selected);
              setOpen(false);
            }}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default React.memo(CheckboxFilterDropdown);
